// extracted by mini-css-extract-plugin
export default {"commentSection":"commentSection__34sO0","showCommentBtn":"showCommentBtn__3v8UY"};